module.exports = __webpack_public_path__ + "static/media/manager-promo.9007e73e.webp";